import React, { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch, useHistory } from 'dva';
import router from 'umi/router';
import Header from 'components/Header/index.js';
import classNames from 'classnames';

import Empty from 'components/EmptyItem/index.jsx';
import { getAgentId, getUrlParam, getLanguage, getValue } from '@/utils/getValue.ts';

import styles from './index.less';

import iconShow from 'images/icon_show.png';
import iconHide from 'images/icon_hide.png';
import iconEnter from 'images/ico_enter_grey@2x.png';

import lgText from '../../config/language';
import { getShowTopBar } from '../../utils/getValue';
import getSpecialClassName from '@/utils/special/specialClassName';
import EmptyItem from 'components/EmptyItem/index.jsx';

export default function Airport() {
  const dispatch = useDispatch();
  const showTopBar = getShowTopBar();
  const [limitIdxKey, setLimitIdxKey] = useState<null | string>(null); // 是否点击了筛选条件
  const airportState = useSelector((state: any) => state.airport);
  const { loungeData, loungeActKey, selectScreen, tagList, tagIdx, limitData, showMoreScreen } =
    airportState;

  const loungeTypeList = Object.keys(loungeData); // 休息室类型
  const navLen = loungeTypeList.length;
  const actLimits = limitData[loungeActKey] || [];
  const actData = loungeData[loungeActKey] || {}; // 当前休息室类型
  const actSelectScreen = selectScreen[loungeActKey] || {}; // 当前休息室类型选中的筛选条件
  const isShowScreenBox = !!limitIdxKey; // 是否显示筛选条件内容
  const actShowMore = showMoreScreen[loungeActKey] || {};
  const isShowTag = tagList.length !== 0;
  const lg = getLanguage();

  const { list = [], noList = [], screenList } = actData;
  const hasNoList = noList.length !== 0;
  let loungeList = list || [];
  if (loungeList.length === 0 && hasNoList) loungeList = noList;
  const hasLoungeList = loungeList.length !== 0;
  const history = useHistory();
  const { name } = (history.location as any).query;
  const dragoncode = getValue('dragoncode');

  // 图片是否需要裁剪效果，目前只有中信需要
  const agentId = getAgentId();
  const showFitCoverProjects = ['12002'];
  const isShowFitCover = showFitCoverProjects.includes(agentId);

  useEffect(() => {
    resetScreen();
    resetShowMore();
    getNetworkDetail(true);
  }, []);

  const getNetworkDetail = (isInit = false) => {
    const iataCode = getUrlParam('iataCode');
    const onlyShowType = getUrlParam('onlyShowType');
    const payload: any = {
      sid: getUrlParam('sid'),
      language: lg,
      agentId: getAgentId(),
      isInit,
    };
    if (iataCode) payload.iataCode = iataCode;
    if (onlyShowType) payload.onlyShowType = onlyShowType;
    if (dragoncode) payload.dragoncode = dragoncode;
    // 判断如果数组，改成string类型，逗号隔开
    const screenKey = Object.keys(actSelectScreen);
    if (screenKey.length !== 0) {
      screenKey.forEach((el) => {
        let val = actSelectScreen[el];
        if (Array.isArray(val)) {
          val = val.join(',');
        }
        payload[el] = val;
      });
    }
    dispatch({
      type: 'airport/queryNetworkDetail',
      payload,
    });
  };

  const toLounge = (code) => {
    router.push({
      pathname: '/lounge',
      query: {
        code,
        language: lg,
      },
    });
  };

  // 保存数据
  const setData = (props: { [ke: string]: any }) => {
    dispatch({
      type: 'airport/setData',
      payload: props,
    });
  };
  // 保存当前筛选项数
  const setScreen = (name: string, type: string, isCanMore = false) => {
    const newSelectScreen = { ...selectScreen };
    const actSelect = newSelectScreen[loungeActKey] || {};
    // 判断是否可以多选
    // 多选项的处理
    if (isCanMore) {
      // 当前项是否已经有数据，若有数据，没有当前name，添加，如果有了，删除当前name
      const hasData = !!actSelect[type];
      if (!hasData) actSelect[type] = [name];
      if (hasData) {
        const arr = actSelect[type] as Array<any>;
        const nameIdx = arr.indexOf(name);
        if (nameIdx === -1) {
          actSelect[type].push(name);
        } else {
          actSelect[type].splice(nameIdx, 1);
        }
      }
    }
    // 单选项的处理
    if (!isCanMore) {
      if (actSelect[type] === name) {
        delete actSelect[type];
      } else {
        actSelect[type] = name;
      }
    }

    newSelectScreen[loungeActKey] = actSelect;
    setData({
      selectScreen: newSelectScreen,
    });
  };
  // 展开更多筛选条件
  const onChangeShowMore = (type: string) => {
    const newShowMoreScreen = { ...showMoreScreen };
    const selfMoreScreen = newShowMoreScreen[loungeActKey] || {};
    const selfMore = selfMoreScreen[type] || false;
    selfMoreScreen[type] = !selfMore;
    newShowMoreScreen[loungeActKey] = selfMoreScreen;
    setData({
      showMoreScreen: newShowMoreScreen,
    });
  };
  // 重置筛选条件
  const resetScreen = () => {
    const newSelectScreen = { ...selectScreen };
    newSelectScreen[loungeActKey] = {};
    setData({
      selectScreen: newSelectScreen,
    });
  };
  // 重置展开更多
  const resetShowMore = () => {
    const newShowMoreScreen = { ...showMoreScreen };
    newShowMoreScreen[loungeActKey] = {};
    setData({
      selectScreen: newShowMoreScreen,
    });
  };
  // 点击切换休息室类型
  const onChangeLoungeType = (loungeType: string) => {
    setData({ loungeActKey: loungeType });
    setLimitIdxKey(null);
  };
  // 确定筛选项
  const onSelectScreen = () => {
    setLimitIdxKey(null);
    getNetworkDetail();
  };

  const screenBox = () => {
    if (!isShowScreenBox) return null;
    return (
      <div className={styles.screenBox}>
        <div className={styles.screenListBox}>
          {screenList.map((el) => {
            const { name, list = [], type, isMulti } = el;
            if (!list || list.length === 0) return null;
            const isAll = limitIdxKey === 'all';
            const isCanMore = isMulti === 1; // 1可以多选  0不能多选
            // 如果不是点筛选按钮展示全部筛选项，只展示当前筛选项的内容
            if (!isAll && type !== limitIdxKey) return null;
            const isShowMore = actShowMore[type];
            const showMoreText = list.length > 6;
            return (
              <div className={styles.item} key={`screen_${type}`}>
                {isAll && <span className={styles.screenTitle}>{name}</span>}
                <div className={styles.screenList}>
                  {list.map((li, idx) => {
                    if (showMoreText && !isShowMore && idx > 5) return null;
                    let isAct = li === actSelectScreen[type];
                    if (isCanMore) {
                      isAct = (actSelectScreen[type] || []).includes(li);
                    }
                    const classname = classNames([styles.screenLi, { [styles.act]: isAct }]);
                    return (
                      <span
                        key={`screenli_${idx}`}
                        className={classname}
                        onClick={() => setScreen(li, type, isCanMore)}
                      >
                        {li}
                      </span>
                    );
                  })}
                </div>
                {showMoreText && (
                  <div className={styles.showMoreBox} onClick={() => onChangeShowMore(type)}>
                    {isShowMore ? lgText['收起'] : lgText['展开']}
                    <img className={styles.icon} src={iconEnter} alt="" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className={styles.btnBox}>
          <div className={styles.btns}>
            <div className={styles.resetBtn} onClick={() => resetScreen()}>
              {lgText['重置']}
            </div>
            <div className={styles.confirmBtn} onClick={() => onSelectScreen()}>
              {lgText['确认']}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 判断是否有数据 20230428起曾东/卢军志等有一批休息室需要隐藏，如果用户筛选出得条件只返回一个休息室，刚好这个休息室需要隐藏，那么整个导航栏都隐藏了，没办法重置筛选项，所以需要注释掉代码,若后面没问题可删
  // const hasData = loungeTypeList.some((el) => {
  //   const info = loungeData[el];
  //   const { list = [], noList = [] } = info;
  //   if (list.length !== 0 || noList.length !== 0) return true;
  // });
  // if (!hasData) {
  //   return (
  //     <div className={styles.airportPage}>
  //       <Header title={name} />
  //       <Empty style={{ marginTop: '2rem' }} />
  //     </div>
  //   );
  // }
  return (
    <div className={styles.airportPage}>
      <Header title={name} />
      <div className={styles.headerBox} style={{ paddingTop: showTopBar ? '1rem' : '0' }}>
        {/* 休息室类型 */}
        <div
          className={styles.loungeTypeBox}
          style={{ justifyContent: navLen > 2 ? 'flex-start' : 'center' }}
        >
          {loungeTypeList.map((el) => {
            const info = loungeData[el];
            return (
              <div
                key={`nav_${el}`}
                className={classNames(styles.item, {
                  [styles.act]: el === loungeActKey,
                })}
                onClick={() => onChangeLoungeType(el)}
              >
                <span className={styles.text}>{info.navName}</span>
              </div>
            );
          })}
        </div>
        {/* 限制筛选条件 */}
        <div className={styles.screenWrap}>
          <div className={styles.limitBox}>
            {actLimits.map((el) => {
              const { name, type } = el;
              const isAct = type === limitIdxKey;
              const icon = isAct ? iconHide : iconShow;
              const classname = classNames([styles.item, { [styles.act]: isAct }]);
              const limitName = actSelectScreen[type] || name;
              return (
                <div
                  className={classname}
                  key={`limit_${type}`}
                  onClick={() => setLimitIdxKey(type)}
                >
                  <span>{limitName}</span>
                  <img className={styles.icon} src={icon} alt="" />
                </div>
              );
            })}
          </div>
          {screenBox()}
        </div>
        {/* 标签  */}
        {isShowTag && (
          <div className={styles.tagListBox}>
            {tagList.map((el, idx) => (
              <span
                className={classNames([
                  styles.item,
                  {
                    [styles.act]: idx === tagIdx,
                  },
                ])}
                key={`tag_${idx}`}
              >
                {el}
              </span>
            ))}
          </div>
        )}
      </div>
      {/* 商品列表 */}
      {hasLoungeList && (
        <div className={styles.loungeListBox}>
          {hasNoList && (
            <Fragment>
              <EmptyItem letter={lgText['noTips']} />
              <div className={styles.noListText}>
                <span>{lgText['NoLoungeTip']} </span>
              </div>
            </Fragment>
          )}
          {loungeList.map((el: any, idx: number) => {
            const {
              name,
              locationGuide,
              imgUrl,
              itemNameList = [],
              code,
              loungeStatus,
              serviceInfoLimitList = [],
            } = el;
            // 判断是否显示航司限制提示，X0004 就是航司限制
            const flightLimit = serviceInfoLimitList.find((el: any) => el.limitsCode === 'X0004');
            if (flightLimit) {
              itemNameList.push('限指定航司乘客可使用');
            }
            const showTags = itemNameList.length !== 0;
            return (
              <div
                className={styles.item}
                key={`tag_${idx}`}
                onClick={() => {
                  toLounge(code);
                }}
              >
                <img
                  className={classNames([styles.loungeImg, { [styles.fitCover]: isShowFitCover }])}
                  style={{ flexShrink: 0 }}
                  src={imgUrl}
                  alt=""
                />
                <div className={styles.loungeInfo}>
                  <span className={styles.name}>{name}</span>
                  <span className={styles.desc}>{locationGuide}</span>
                  {showTags && (
                    <div className={styles.loungeTags}>
                      {itemNameList.map((el: any, tagIdx: number) => {
                        // 因为接口可能返回null
                        return el ? (
                          <span className={styles.item} key={`tag_${tagIdx}`}>
                            {el}
                          </span>
                        ) : null;
                      })}
                    </div>
                  )}
                </div>
                {loungeStatus && (
                  <span
                    style={{
                      background: '#ff3030',
                      color: '#fff',
                      whiteSpace: 'nowrap',
                      padding: '2px 8px',
                      fontSize: '0.24rem',
                      marginLeft: '4px',
                    }}
                  >
                    {loungeStatus?.statusName?.slice(2)}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )}
      {!hasLoungeList && <Empty style={{ marginTop: '2rem' }} />}
      {/* 筛选条件的遮罩层 */}
      {isShowScreenBox && <div className={styles.mask}></div>}
    </div>
  );
}
